import { ChangeEventHandler } from "react";

interface ToogleSwitchProps {
  checked?: boolean;
  title?: string;
  toogleSwitch: ChangeEventHandler<HTMLInputElement>;
}

const FilterToogleSwitch: React.FC<ToogleSwitchProps> = ({
  checked,
  title,
  toogleSwitch,
}) => {
  return (
    <label className="switch" onClick={(e) => e.stopPropagation()}>
      <input type="checkbox" checked={checked} onChange={toogleSwitch} />
      <span className="slider">{title}</span>
    </label>
  );
};

export default FilterToogleSwitch;
